import { useMemo } from 'react';

export function useNewBillingStartingDateComponents(): { year: number; month: number } {
  console.log(import.meta.env.VITE_NEW_BILLING_START_DATE);

  return useMemo((): { year: number; month: number } => {
    const minDateStr = import.meta.env.VITE_NEW_BILLING_START_DATE;

    if (!minDateStr) {
      return { year: 2023, month: 11 };
    }

    const [year, month] = minDateStr.split('-');

    return {
      year: Number(year),
      month: Number(month),
    };
  }, []);
}
